import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { loadUser } from 'redux-oidc';
import rootReducer from 'store/rootReducer';
import userManager from 'lib/auth/UserManager';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, undefined, composeEnhancers(applyMiddleware(thunk)));

loadUser(store, userManager);

export default store;
